import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import api from "../api";
import { toast } from "react-toastify";

const handleDownload = async (title) => {
  const formData = new FormData();
  formData.append("file_name", title); // Ensure the correct file_name is passed

  try {
    const response = await api.post("/download-sample-file", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      responseType: "blob", // Receive response as binary data
    });

    // Create a Blob from the response data
    const blob = new Blob([response.data], { type: "text/csv" });

    // Create a link element
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);

    // Set the download attribute with a filename
    link.download =`sample_${title}.csv`;

    // Append to the document and trigger download
    document.body.appendChild(link);
    link.click();

    // Remove the link element after download
    document.body.removeChild(link);
    toast.success("File downloaded successfully!");

  } catch (error) {
    console.error(error);
    toast.error("Failed to Download. Please try again.");
  } finally {
    // Cleanup or additional actions
    console.log("Download attempt completed.");
  }
};

const Breadcrumbs = (props) => {
  const location = useLocation();
  const { id } = useParams();
  const userType = localStorage.getItem("type");
  let addButton = null;

  if (
    [
      "/form-basic-inputs",
      "/form-input-groups",
      "/form-horizontal",
      "/form-vertical",
      "/form-mask",
      "/form-validation",
      "/tables-basic",
      "/data-tables",
      "/performance",
      "/payments",
      "/ui/components",
      "/adminattendance",
      "/attendance-employee",
      "/task-board",
      "/leads",
      "/create-estimate",
      "/edit-estimate",
      "/create-invoice",
      "/edit-invoice",
      "/payroll-items",
      "/activities",
      "/expense-reports",
      "/invoice-reports",
      "/payments-reports",
      "/task-reports",
      "/user-reports",
      "/payslip-reports",
      "/attendance-reports",
      "/user-dashboard",
      "/user-all-jobs",
      "/saved-jobs",
      "/interviewing",
      "/offered-jobs",
      "/visited-jobs",
      "/knowledgebase",
      "/questions",
      "/jobs-dashboard",
      "/manage-resumes",
      "/shortlist-candidates",
      "/offer_approvals",
      "/schedule-timing",
      "/apptitude-result",
      "/job-aptitude",
      "/applied-jobs",
      "/offered-jobs",
      "/archived-jobs",
      "/subscriptions-company",
      "/subscribed-companies",
      "/profile",
      "/job-list",
      "/job-view",
      "/search",
      "/faq",
      "/blank-page",
      "/user-asset-details",
      "/leaves-setting",
      "/project-reports",
      "/client-profile",
      "/role",
      "/payroll",
      "/esic-pf",
      "/report",
      "/folder-list",
      userType === "Admin" && "/employee",
      "/track-sheet",
      `/salary-view/${id}`,
    ].includes(location.pathname)
  ) {
    addButton = (
      <div className="row">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/role">{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul>
        </div>
      </div>
    );
  } else if (
    [
      "/settings/company-settings",
      "/settings/localization",
      "/settings/theme-settings",
      "/settings/roles-permissions",
      "/settings/approval-setting",
      "/settings/invoice-settings",
      "/settings/salary-settings",
      "/settings/notifications-settings",
      "/settings/toxbox-setting",
      "/settings/cron-setting",
    ].includes(location.pathname)
  ) {
    addButton = (
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">{props.maintitle}</h3>
        </div>
      </div>
    );
  } else if (location.pathname === "/admin-dashboard") {
    addButton = (
      <div className="row">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item active">{props.title}</li>
          </ul>
        </div>
      </div>
    );
  } else if (location.pathname === "/invoice-view") {
    addButton = (
      <div className="row">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/admin-dashboard">{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul>
        </div>
        <div className="col-auto float-end ms-auto">
          <div className="btn-group btn-group-sm">
            <button className="btn btn-white">CSV</button>
            <button className="btn btn-white">PDF</button>
            <button className="btn btn-white">
              <i className="fa-solid fa-print fa-lg" /> Print
            </button>
          </div>
        </div>
      </div>
    );
  } else if (
    [
      "/projects",
      "/clients",
      "/clients-list",
      "/project-list",
      "/employees",
      "/employees-list",
    ].includes(location.pathname)
  ) {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/admin-dashboard">{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul>
        </div>
        <div className="col-auto float-end ms-auto">
          <Link
            to="#"
            className="btn add-btn"
            onClick={props.onAddClick} // Use React onClick to open modal
          >
            <i className="fa fa-plus" /> {props.name}
          </Link>
          <div className="view-icons">
            <Link
              to={props.Linkname}
              className="grid-view btn btn-link active mx-2"
            >
              <i className="fa fa-th" />
            </Link>
            <Link to={props.Linkname1} className="list-view btn btn-link">
              <i className="fa fa-bars" />
            </Link>
          </div>
        </div>
      </div>
    );
  } else if (["/estimates", "/invoices"].includes(location.pathname)) {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/admin-dashboard">{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul>
        </div>
        <div className="col-auto float-end ms-auto">
          <Link
            to="#"
            className="btn add-btn"
            onClick={props.onAddClick} // React onClick instead of data-bs-target
          >
            <i className="fa fa-plus" />
            {props.name}
          </Link>
        </div>
      </div>
    );
  } else if (
    ["/employee-reports", "/leave-reports", "/daily-reports"].includes(
      location.pathname
    )
  ) {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/admin-dashboard">{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul>
        </div>
        <div className="col-auto">
          <Link to="#" className="btn btn-primary">
            PDF
          </Link>
        </div>
      </div>
    );
  } else if (["/employee-bank-details"].includes(location.pathname)) {
    addButton = (
      <div className="row">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/role">{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul>
        </div>
        {/* Dynamic buttons */}
        <div className="col-auto float-end ms-auto">
          {props.actions &&
            props.actions.map((action, index) => (
              <button
                key={index}
                className={action.className || "btn btn-primary me-2"}
                onClick={action.onClick}
              >
                {action.label}
              </button>
            ))}
        </div>
      </div>
    );
  } else {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/admin-dashboard">{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul>
        </div>
        <div className="col-auto float-end ms-auto">
   
        <Link
          to="#"
          className="btn add-btn"
          onClick={props.onAddClick} 
        >
          <i className="fa fa-plus" />
          {props.name}
        </Link>
        {props.subtitle !== 'User' && (  
          <Link
            to="#"
            className="btn btn-success"
            onClick={() => handleDownload(props.subtitle)} 
          >
            Download Sample File
          </Link>
        )}
    </div>
      </div>
    );
  }

  return <div className="page-header">{addButton}</div>;
};

export default Breadcrumbs;
